import { Component, OnDestroy, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * Where an invited administrator lands. The link carries a single-use token;
 * the password is chosen here and never travels in an email.
 */
@Component({
  selector: "app-set-password",
  templateUrl: "./set-password.component.html",
  styleUrls: ["./set-password.component.css"],
})
export class SetPasswordComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  state: "checking" | "ready" | "invalid" | "done" = "checking";
  name = "";
  email = "";
  password = "";
  confirm = "";
  showPassword = false;
  error = "";
  busy = false;

  private token = "";

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get("token") || "";
    if (!this.token) {
      this.state = "invalid";
      this.error = "This link is missing its token.";
      return;
    }
    this.http
      .get<{ valid: boolean; name: string; email: string }>(
        environment.baseUrl + "public/admin-invite?token=" + encodeURIComponent(this.token),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => { this.name = res.name; this.email = res.email; this.state = "ready"; },
        err => { this.error = this.reason(err, "This link is no longer valid."); this.state = "invalid"; },
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submit() {
    if (this.password.length < 10) { this.error = "Use at least 10 characters."; return; }
    if (this.password !== this.confirm) { this.error = "Passwords do not match."; return; }

    this.busy = true;
    this.error = "";
    this.http
      .post(environment.baseUrl + "public/admin-invite", { token: this.token, password: this.password })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => { this.busy = false; this.state = "done"; },
        err => { this.busy = false; this.error = this.reason(err, "Could not set the password."); },
      );
  }

  goToLogin() {
    this.router.navigate(["/login"]);
  }

  private reason(err: any, fallback: string): string {
    return (err && err.error && err.error.error) || fallback;
  }
}
